// Import polyfills first to ensure compatibility with older packages
import './polyfills'

// react library for routing
import React from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { Provider } from 'react-redux'

// plugins styles from node_modules
import 'react-notification-alert/dist/animate.css'
import 'react-perfect-scrollbar/dist/css/styles.css'
import '@fullcalendar/common/main.min.css'
import '@fullcalendar/daygrid/main.min.css'
import 'sweetalert2/dist/sweetalert2.min.css'
import 'select2/dist/css/select2.min.css'
import 'quill/dist/quill.core.css'
import '@fortawesome/fontawesome-free/css/all.min.css'
import '@fortawesome/fontawesome-svg-core/styles.css'
// plugins styles downloaded
import 'assets/vendor/nucleo/css/nucleo.css'
// core styles
import 'assets/scss/argon-dashboard-pro-react.scss?v1.2.0'

import store from './store'
import Main from 'Main'
import config from 'config'
import ErrorBoundary from './components/ErrorBoundary'

// Change the name of the tab name
document.title = config.title

// Create root for React 18
const container = document.getElementById('root')
const root = createRoot(container)

// Render app with React 18 createRoot
root.render(
  <ErrorBoundary>
    <Provider store={store}>
      <BrowserRouter>
        <Main />
      </BrowserRouter>
    </Provider>
  </ErrorBoundary>
)
